import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import {
  BADGE_ASSIGNMENT_CACHE_FIELDS,
  BADGE_CACHE_FIELDS,
} from '@/client/exchanges/cacheExchange/constants';
import invalidateFields, {
  type FieldInvalidationCache,
} from '@/client/exchanges/cacheExchange/invalidateFields';

export function invalidateDeletedBadgeFields(cache: FieldInvalidationCache) {
  invalidateFields(
    [...BADGE_CACHE_FIELDS, ...BADGE_ASSIGNMENT_CACHE_FIELDS],
    cache,
  );
}

export default function delete_badge_by_pk(
  _parent: unknown,
  _args: unknown,
  cache: Cache,
  _info: ResolveInfo,
) {
  invalidateDeletedBadgeFields(cache);
}
